<template>
  <div>
    <a-row :gutter="16">
      <a-col :span="24" :md="8" :xl="6" style="max-width: 256px; margin-bottom: 12px">
        <a-input-search v-model="searchForm.search" placeholder="单号" allowClear @search="search" />
      </a-col>
      <!-- <a-col :span="24" :md="8" :xl="6" style="max-width: 256px; margin-bottom: 12px;">
        <a-range-picker @change="onChangePicker" />
      </a-col> -->
    </a-row>

    <a-row style="margin-top: 12px">
      <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading"
        :pagination="pagination" @change="tableChange" :scroll="{ y: 575 }"
>
        <div slot="action" slot-scope="value, item">
          <a-button-group size="small">
            <a-button size="small" @click="detial(item)">详情</a-button>
            <a-button type="primary" size="small" :disabled="item.is_completed || item.is_void"
              @click="toStockIn(item)"
>
              出库
            </a-button>
          </a-button-group>
        </div>
      </a-table>
    </a-row>
  </div>
</template>

<script>
import { stockOutOrdersList, stockOutOrdersVoid } from "@/api/warehouse";
import { saleOrderList } from "@/api/sale";

export default {
  name: "SaleRecord",
  components: {},
  data() {
    return {
      columns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          customRender: (value, item, index) => {
            return index + 1;
          },
          width: 45,
        },
        {
          title: "出库编号",
          dataIndex: "number",
          sorter: true,
        },
        {
          title: "销售单号",
          dataIndex: "sales_order_number",
          sorter: true,
        },
        {
          title: "仓库",
          dataIndex: "warehouse_name",
        },
        {
          title: "出库类型",
          dataIndex: "type_display",
        },
        {
          title: "出库完成状态",
          dataIndex: "is_completed",
          customRender: (value, item, index) => {
            return item.is_completed ? "完成" : "待出库";
          },
        },
        {
          title: "状态",
          dataIndex: "is_void",
          customRender: (value, item, index) => {
            return item.is_void ? "已作废" : "正常";
          },
        },
        {
          title: "发生日期",
          dataIndex: "occur_date_display",
          width: 170,
          customRender: (value, item) => {
            return item.occur_date_display || (item.is_void ? "订单已作废" : "加载中...");
          },
        },
        {
          title: "创建日期",
          dataIndex: "create_time",
          width: 170,
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          width: 147,
        },
      ],
      searchForm: { page: 1, is_completed: false, page_size: 16 },
      pagination: { current: 1, total: 0, pageSize: 50 },
      loading: false,
      items: [],
      visible: false,
      targetItem: {},
      form: {},
    };
  },
  computed: {},
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.list();
    },
    list() {
      this.loading = true;
      stockOutOrdersList(this.searchForm)
        .then((data) => {
          this.pagination.total = data.count;
          this.items = data.results;
          // 补充发生日期显示：非作废从销售单获取handle_time，作废显示“订单已作废”
          this.fillOccurDates();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async fillOccurDates() {
      const tasks = (this.items || []).map(async (row) => {
        if (row.is_void) {
          this.$set(row, "occur_date_display", "订单已作废");
          return;
        }
        try {
          // 通过销售单号查询销售记录以拿到发生日期(handle_time)
          if (row.sales_order_number) {
            const data = await saleOrderList({ search: row.sales_order_number, page_size: 1 });
            const match = (data.results || []).find((r) => r.number === row.sales_order_number) || (data.results || [])[0];
            this.$set(row, "occur_date_display", match && match.handle_time ? match.handle_time : "");
          } else {
            this.$set(row, "occur_date_display", "");
          }
        } catch (e) {
          this.$set(row, "occur_date_display", "");
        }
      });
      await Promise.all(tasks);
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.searchForm.page_size = pagination.pageSize;
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.searchForm.ordering = `${sorter.order == "descend" ? "-" : ""}${sorter.field}`;
      this.list();
    },
    onChangePicker(date, dateString) {
      let startDate = date[0],
        endDate = date[1];
      this.searchForm.start_date = startDate ? startDate.format("YYYY-MM-DD") : undefined;
      this.searchForm.end_date = endDate ? endDate.add(1, "days").format("YYYY-MM-DD") : undefined;
      this.search();
    },
    search() {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    toStockIn(item) {
      this.$router.push({ path: "/warehouse/outStock_create", query: { id: item.id } });
    },
    detial(item) {
      this.$router.push({ path: "/warehouse/outStock_detail", query: { id: item.id } });
    },
    voidItem(item) {
      stockOutOrdersVoid({ id: item.id }).then(() => {
        this.$message.success("作废成功");
        this.list();
      });
    },
  },
};
</script>
